'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './user-directory.routes';

export class UserDirectoryComponent {
  constructor(User, DTOptionsBuilder, $state, Config, Auth) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "User Directory");
    this.Auth = Auth;
    this.loggedIn = false;

    this.permissions = Config.getModuleConfig(Config.Modules.Profile).getPermissions();
    this.useShortAddr = Config.getModuleConfig(Config.Modules.Profile).getUseShortAddressFormat();

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lfrtip')
      .withOption('responsive', true)
      .withOption('pageLength', 50)
      .withOption('hasBootstrap',true)
      .withOption('order', [0, 'asc']);

    if (Auth.isLoggedInSync()) {
      this.loggedIn = true;
      this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('pageLength', 50)
      .withOption('hasBootstrap',true)
      .withOption('order', [0, 'asc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'User Directory'
      },{
        extend: 'csv',
        title: 'User Directory'
      },{
        title: 'User Directory',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);
    }

    User.query(users => {
      let data = users.filter(user => user.active && user.role.includes("member"));

      this.data = data.map(user => {

        let workPhone = user.profile.phone.find(phone => phone.type == 'Work');
        let publicCellPhone = user.profile.phone.find(phone => phone.type == 'Cell' && !phone.private);

        if (workPhone)
          user.workPhone = workPhone.number;

        if (publicCellPhone)
          user.cellPhone = publicCellPhone.number;

        return user;
      });
    });
  }

  formatPhone(number) {
    if (!number)
      return "-";

    try {
      var f_val = number.replace(/[^0-9]/g, "");
      return f_val.slice(0,3)+"-"+f_val.slice(3,6)+"-"+f_val.slice(6);
    } catch(err) {
      return "-";
    }

  }

  formatAddress(adr) {
    if (this.useShortAddr && adr.type != 'Other') {

      return adr.street;


    } else {

      let oAdr = [];

      oAdr.push(adr.street);
      oAdr.push("<br/>");
      if (adr.street2) {
        oAdr.push(adr.street2);
        oAdr.push("<br/>");
      }
      oAdr.push(adr.city);
      oAdr.push(", ");
      oAdr.push(adr.state);
      oAdr.push(" ");
      oAdr.push(adr.zip);
      if (adr.country) {
        oAdr.push("<br/>");
        oAdr.push(adr.country);
      }

      return oAdr.join("");

    }
  }

  hasPermission(field) {
    if (!this.permissions.hasOwnProperty(field))
      return true;

    return this.Auth.getCurrentUserSync().role.some(r => this.permissions[field].includes(r));
  }
}

export default angular.module('conduuApp.userDirectory', [uiRouter])
  .config(routes)
  .component('userDirectory', {
    template: require('./user-directory.html'),
    controller: UserDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/user/user-directory.component.js